<script>
  import { _ } from "svelte-i18n"
</script>

<span class="icon-cloud-done" title="{$_('preview.uploaded')}">
  <svg class="icon"><use xlink:href="#icon-cloud-done"/></svg>
</span>

<style>
  .icon-cloud-done {
    display: inline-block;
    width: 1.6rem;
    height: 1.6rem;
    margin-right: 0.2rem;
    margin-left: -2rem;
    vertical-align: text-top;
  }
  .icon-cloud-done:hover .icon {
    stroke: var(--c-text);
  }
  .icon-cloud-done .icon {
    width: 2rem;
    height: 2rem;
    stroke: var(--c-text-faded-big);
  }
</style>